import Vue from 'vue';
import {
  Button,
  Select,
  Input,
  OptionGroup,
  Option,
  Checkbox,
  Dropdown,
  MenuItem,
  Tooltip,
  Popover,
} from '@kdocs/kdesign-vue';
import '@kdocs/kdesign-vue/lib/theme-chalk/index.css';
import '@kdocs/kdesign-theme/default.css';

Vue.use(Button);
Vue.use(Input);
Vue.use(Select);
Vue.use(OptionGroup);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(Dropdown);
Vue.use(MenuItem);
Vue.use(Tooltip);
Vue.use(Popover);
